import fx from "utils/fx";
import AxiosInterceptor from "api/interceptor";

const discount = new AxiosInterceptor();

export default {
  get(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return new Promise((resolve, reject) => {
      discount
        .get("/discount?" + qstr)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  find(id) {
    return new Promise((resolve, reject) => {
      discount
        .get("/discount/" + id)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  create(inputs) {
    return discount.post("/discount", {
      name: inputs.name,
      description: inputs.description,
      type: inputs.type,
      max_uses: inputs.max_uses,
      max_uses_user: inputs.max_uses_user,
      amount: inputs.amount,
      amount_type: inputs.amount_type,
      start_at: inputs.start_at,
      expire_at: inputs.expire_at,
      min_items: inputs.min_items,
      min_amount: inputs.min_amount,
      applied_products: inputs.applied_products,
      applied_categories: inputs.applied_categories,
      code: inputs.code,
      event_type: inputs.event_type,
    });
  },
  update(id, inputs) {
    return discount.put("/discount/" + id, {
      name: inputs.name,
      description: inputs.description,
      type: inputs.type,
      max_uses: inputs.max_uses,
      max_uses_user: inputs.max_uses_user,
      amount: inputs.amount,
      amount_type: inputs.amount_type,
      start_at: inputs.start_at,
      expire_at: inputs.expire_at,
      min_items: inputs.min_items,
      min_amount: inputs.min_amount,
      applied_products: inputs.applied_products,
      applied_categories: inputs.applied_categories,
      event_type: inputs.event_type,
    });
  },
  delete(id) {
    return discount.delete("/discount/" + id);
  },
  active(id, active) {
    return discount.put("/discount/" + id + "/active", {
      is_active: active,
    });
  },
  getActiveDiscount() {
    return discount.get("/discount/available");
  },
  getOrderUsagesSummary(id, qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return discount.get("/discount/" + id + "/order-usages-summary" + (qstr ? "?" + qstr : ""));
  },
};
